import React from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import InlineSvg from './InlineSvg';
import { StaticImage } from 'gatsby-plugin-image';
import { navigate } from 'gatsby';
import { toSnakeCase } from '../helpers/common';

const selectStyles = {
  control: (provided, state) => {
    const borderColor = state.menuIsOpen ? '#FFF' : '#FFF';
    const borderRadius = state.menuIsOpen ? '8px 8px 0 0' : '8px';
    const borderWidth = state.menuIsOpen ? '1px 1px 0 1px' : '1px';
    const background = state.menuIsOpen ? '#1E398D' : 'transparent';
    return {
      borderRadius: borderRadius,
      borderColor: borderColor,
      borderStyle: 'solid',
      borderWidth: borderWidth,
      display: 'flex',
      padding: '16px 16px 14px',
      cursor: 'pointer',
      background: background,
      fontSize: '16px',
      lineHeight: '1.7',
    };
  },
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: (provided) => {
    return {
      ...provided,
      color: '#FFF',
    };
  },
  singleValue: (provided) => ({
    ...provided,
    fontSize: '16px',
    color: '#FFF',
  }),
  placeholder: (provided, state) => {
    const display = state.isFocused && !state.hasValue ? 'none' : 'block';
    return {
      ...provided,
      fontSize: '16px',
      color: '#FFF',
      display: display,
    };
  },
  menu: (provided) => ({
    ...provided,
    padding: '0',
    borderRadius: '0 0 8px 8px',
    background: '#1E398D',
    border: 'none',
    boxShadow: 'rgba(18, 24, 31, 0.05)',
    marginTop: '0',
    color: '#FFF',
    zIndex: '10',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '10px 0',
    borderRadius: '0 0 8px 8px',
    borderStyle: 'solid',
    borderWidth: '0 1px 1px 1px',
    borderColor: '#FFF',
    position: 'relative',
  }),
  option: (provided, state) => {
    let color = '#FFF';
    let backgroundColor = 'transparent';
    if (state.isFocused || state.isSelected) {
      color = '#FFF';
      backgroundColor = 'rgba(255, 255, 255, 0.1)';
    }
    return {
      ...provided,
      cursor: 'pointer',
      color: color,
      padding: '5px 25px',
      lineHeight: '1.65',
      fontSize: '16px',
      '&:active': {
        color: color,
        backgroundColor: backgroundColor,
      },
      backgroundColor: backgroundColor,
    };
  },
  noOptionsMessage: (provided) => {
    return {
      ...provided,
      color: '#FFF',
      textAlign: 'left',
      padding: '8px 24px',
    };
  },
  loadingMessage(provided) {
    return {
      ...provided,
      color: '#FFF',
      opacity: '0.6',
      textAlign: 'left',
      padding: '8px 24px',
    }
  },
};
const OutageChecker = (props) => {
  const [showGooglePlacesAutocomplete, setShowGooglePlacesAutocomplete] = React.useState(false);
  const outageCheckerLinks = props.module.outageCheckerLinks;
  const outageMapKey = process.env.GATSBY_GOOGLE_MAPS_KEY;
  const DropdownIndicator = () => {
    return (
      <InlineSvg
        name="search"
        color="white"
        className="outage-checker__search-svg"
      />
    );
  };

  React.useEffect(() => {
    setShowGooglePlacesAutocomplete(true);
  }, []);

  return (
    <section
      className="outage-checker__section"
      id={
        props?.module?.anchorTagLinkText &&
        `${toSnakeCase(props.module.anchorTagLinkText)}`
      }
    >
      <div className="outage-checker__wrapper">
        <div className="outage-checker__content-container">
          <h2 className="outage-checker__heading heading-two">
            {props?.module?.title}
          </h2>
          <div className="outage-checker__search-box-container">
            <label hidden htmlFor="search-outage">
              search
            </label>
            {showGooglePlacesAutocomplete ? (
              <GooglePlacesAutocomplete
                apiKey={outageMapKey}
                selectProps={{
                  styles: selectStyles,
                  openMenuOnFocus: false,
                  openMenuOnClick: false,
                  placeholder: 'Search',
                  components: {
                    DropdownIndicator,
                  },
                  onChange: (searchResult) => {
                    if (searchResult?.value) {
                      const url = encodeURI(
                        `/power-outages-and-emergencies/live-outage-map/?place_id=${searchResult.value.place_id}`
                      );
                      navigate(url);
                    }
                  },
                }}
                autocompletionRequest={{
                  types: ['(regions)'],
                  componentRestrictions: { country: 'au' },
                }}
              />
            ) : null}
          </div>
          <ul className="outage-checker__link-list">
            {outageCheckerLinks
              ? outageCheckerLinks.map((link, i) => (
                  <li key={i} className="outage-checker__list-item">
                    <a
                      href={link?.link?.url}
                      className="decoration outage-checker__list-link"
                      dangerouslySetInnerHTML={{ __html: link?.link?.title }}
                    ></a>
                  </li>
                ))
              : null}
          </ul>
          <div className="outage-checker__desktop-image">
            <StaticImage
              src="../assets/images/outage-map-graphic.png"
              quality={100}
              formats={['png']}
              alt="Check outages in your area"
              objectFit="contain"
            />
          </div>
          <div className="outage-checker__tablet-image">
            <StaticImage
              src="../assets/images/outage-map-graphic.png"
              quality={100}
              formats={['png']}
              alt="Check outages in your area"
              objectFit="contain"
              />
          </div>
          <div className="outage-checker__mobile-image">
            <StaticImage
              src="../assets/images/outage-map-graphic.png"
              quality={100}
              formats={['png']}
              alt="Check outages in your area"
              objectFit="contain"
              height={350}
            
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutageChecker;
